module.exports = __webpack_public_path__ + "img/1.9199eda9.png";